import { debugLog } from '~/shared/utils';

const fetchRequest = (input: RequestInfo, init?: RequestInit | undefined): Promise<Response> => {
    debugLog(input);
    return fetch(input, init);
};

export default fetchRequest;
